import React from 'react';
import { ActionMenu } from "../shared/ActionMenu";

const PredictorTable = ({
    currentItems,
    seeCommentsOfAPredictor,
    seePredictionsOfAPredictor,
    setEditPredictor,
    handleDelete,
}) => {
    return (
        <div className="relative w-full overflow-auto rounded-md border">
            <table className="w-full caption-bottom text-sm">
                <thead className="[&_tr]:border-b bg-muted/50">
                    <tr>
                        <th className="h-12 px-4 text-left align-middle font-medium text-muted-foreground">ID predictor</th>
                        <th className="h-12 px-4 text-left align-middle font-medium text-muted-foreground">Predictor name</th>
                        <th className="h-12 px-4 text-left align-middle font-medium text-muted-foreground">Proficiency score</th>
                        <th className="h-12 px-4 text-right align-middle font-medium text-muted-foreground">Actions</th>
                    </tr>
                </thead>
                <tbody className="[&_tr:last-child]:border-0">
                    {currentItems.map((item) => (
                        <tr key={item.predictor_id} className="border-b transition-colors hover:bg-muted/50">
                            <td className="p-4 align-middle">{item.predictor_id}</td>
                            <td className="p-4 align-middle">{item.predictorname}</td>
                            <td className="p-4 align-middle">{item.proficiency_score}</td>
                            <td className="p-4 align-middle text-right">
                                <ActionMenu
                                    onEdit={() => setEditPredictor(item)}
                                    onDelete={() => handleDelete(item.predictor_id)}
                                    extraActions={[
                                        { label: "Comments", onClick: () => seeCommentsOfAPredictor(item.predictor_id) },
                                        { label: "Predictions", onClick: () => seePredictionsOfAPredictor(item.predictor_id) },
                                    ]}
                                />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default PredictorTable;
